import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/views/projects/ProjectGeneral.scss';
import Image from '../../components/Image';
import {
  __,
  getActiveStage,
  redirect,
  setActiveProject,
  validateForm,
} from '../../core/utils';
import PhotoIcon from '../../assets/images/photo-15x15.svg';
import autobind from 'autobind-decorator';
import { setNotification } from '../../redux/actions/general/notification';
import { createSidebar } from '../../redux/actions/general/sidebar';
import ProjectFinancialForm from '../../forms/projects/ProjectFinancialForm';
import {
  getProjectPermissions,
  readProjectFinancial,
  readProjectGeneral,
  updateProjectFinancial,
  uploadProjectThumbnail,
} from '../../redux/actions/projects';
import {
  enableProjectsDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import classNames from 'classnames';
import Tooltip from '../../components/Tooltip';
import * as _ from 'lodash';
import DefaultImage from '../../assets/images/default.png';

class ProjectFinancial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      project: {},
      financial: {},
      is_project_administrator: false,
    };
  }

  componentDidMount() {
    setActiveProject(this.props.match.params.project);

    getProjectPermissions(this.props.match.params.project).then(
      ({ response }) => {

        const canViewProjectPlanning = _.includes(
          _.get(response.data, 'planning_module_visibility.permissions', []),
          'planning_module_visibility'
        );

        this.setState({
          is_project_administrator: _.get(response.data, 'administrator'),
        });

        enableProjectsDropdown(({ project_id }) =>
          redirect('/projects/' + project_id + '/financial')
        );

        createSidebar({
          title: __('submenu.title.project'),
          items: _.compact([
            {
              title: __('submenu.title.project-properties'),
              active: true,
              items: [
                {
                  title: __('submenu.title.project-general'),
                  link: () => '/projects/' + this.props.match.params.project + '/general',
                },
                {
                  title: __('Financial'),
                  link: () => '/projects/' + this.props.match.params.project + '/financial',
                  active: true,
                },
              ],
            },
            canViewProjectPlanning && {
              title: __('submenu.title.project-planning'),
              link: () =>
                '/projects/' +
                this.props.match.params.project +
                '/project-planning',
            },
            {
              title: __('submenu.title.teams'),
              link: () => '/stages/' + getActiveStage() + '/teams',
            },
            {
              title: __('submenu.title.stages'),
              link: () => '/projects/' + this.props.match.params.project + '/stages',
            },
            {
              title: __('submenu.title.approvers'),
              link: () => '/stages/' + getActiveStage() + '/approvers',
            },
            {
              title: __('submenu.title.import_spreadsheet'),
              link: () => '/import/' + getActiveStage(),
            },
          ]),
        });

        readProjectGeneral(this.props.match.params.project).then(
          ({ response: generalResponse }) => {
            this.setState({
              project: generalResponse.data,
            });

            readProjectFinancial(this.props.match.params.project).then(
              ({ response: financialResponse }) => {
                this.setState({
                  financial: financialResponse.data,
                });

                listActiveModules();
              }
            );
          }
        );
      }
    );
  }

  @autobind
  _handleSubmit(formData) {
    const { financial } = this.state;
    const isDateCleared = formData?.date === '';

    formData = {
      ...formData,
      date: isDateCleared
        ? {
            start: null,
            end: null,
            allDay: 0,
            duration: 0,
            deadline: 0,
          }
        : {
            ...financial?.date,
            ...formData?.date,
          },
    };

    return validateForm(
      updateProjectFinancial(this.props.match.params.project, formData).then(
        () => {
          readProjectFinancial(this.props.match.params.project).then(
            ({ response }) => {
              this.setState({
                financial: response.data,
              });
            }
          );

          listActiveModules();

          setNotification(__('project.general-settings.saved'));
        }
      )
    );
  }

  @autobind
  _handleUploadThumbnail(e) {
    if (e.target.files && e.target.files.length) {
      setNotification(__('project.image-uploaded.wait'));

      uploadProjectThumbnail(
        this.props.match.params.project,
        e.target.files[0]
      ).then(() => {
        setNotification(__('project.image-uploaded.success'));

        readProjectGeneral(this.props.match.params.project).then(
          ({ response }) => {
            this.setState({ project: response.data });
          }
        );
      });
    }
  }

  render() {
    const { project, financial } = this.state;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.logo}>
            <Image
              className={classNames(
                this.state.is_project_administrator && styles.hasAction
              )}
              src={project.image_url}
              default={DefaultImage}
            />
            {this.state.is_project_administrator && (
              <div className={styles.actions}>
                <Tooltip text={__('content.tooltip.project.logo')}>
                  <PhotoIcon onClick={() => this.refs.logo.click()} />
                </Tooltip>
                <input
                  type='file'
                  ref='logo'
                  onChange={this._handleUploadThumbnail}
                  accept='image/x-png,image/jpeg'
                />
              </div>
            )}
          </div>
          <div className={styles.user}>
            <div className={styles.name}>
              <strong>{project.code}:</strong> {project.name}
            </div>
            <div className={styles.info}>
              <span>{_.get(project.description, project.main_language)}</span>
            </div>
          </div>
        </div>
        <div className={styles.content}>
          {!_.isEmpty(project) && !_.isEmpty(financial) && (
            <ProjectFinancialForm
              isProjectAdministrator={this.state.is_project_administrator}
              onSubmit={this._handleSubmit}
              project={project}
              localization={this.props.localization}
              initialValues={{
                ..._.pick(financial, ['currency_id', 'is_billable', 'date']),
              }}
            />
          )}
        </div>
      </>
    );
  }
}

export default ProjectFinancial;
